import MainNav from '@/components/nav/MainNav';
import { SessionProvider } from '../providers/session-provider';
import { PaymentProvider } from '../providers/payment-provider';
import SubscriptionAccessControl from '@/components/SubscriptionAccessControl';
import { TeamPermissionsProvider } from '../providers/team-permissions-provider';
import { Outlet } from 'react-router-dom';
import LegacyIframes from '@/legacy/components/LegacyIframes';
import { AppInitialLoadQuery } from '@/graphql/generated/app-initial-load.generated';
import { Suspense } from 'react';
import PageLayoutLoading from './PageLayoutLoading';
import { SocketProvider } from '@/app/providers/socket-provider';
import NotificationsEmitControl from '@/components/notifications/NotificationsEmitControl';
import { AndieProvider } from '@/providers/andie-provider';
import { MenuProvider } from '@/providers/menu-provider';
import { SecuritySessionProvider } from '@/providers/security-session-provider';
import FinishOnboarding from '@/components/onboarding/FinishOnboarding';
import DevOnboarding from '@/components/onboarding/swonkie-dev/DevOnboarding';
import AndieDrawer from '@/components/andie/AndieDrawer';
import AndieDeepLink from '@/components/andie/AndieDeepLink';
import OverQuotaGate from '@/components/billing/OverQuotaGate';
import XCreditsDialog from '@/components/billing/XCreditsDialog';

interface PrivateLayoutProps {
    data: AppInitialLoadQuery;
    refetch: () => void;
}

export default function PrivateLayout({ data, refetch }: PrivateLayoutProps) {
    return (
        <AndieProvider>
            <SessionProvider initialValue={data}>
                <TeamPermissionsProvider initialValue={data.teamPermissions}>
                    <PaymentProvider>
                        <MenuProvider>
                            <SocketProvider>
                                <MainNav />
                                <SecuritySessionProvider>
                                    <Suspense fallback={<PageLayoutLoading />}>
                                        <Outlet />
                                    </Suspense>
                                </SecuritySessionProvider>
                                <LegacyIframes />
                                <AndieDrawer />
                                <AndieDeepLink />
                                <NotificationsEmitControl />
                                {!data.currentWorkspace.isSwonkieDev && (
                                    <FinishOnboarding
                                        appInitialLoad={{
                                            refetch,
                                            statusLevelCount: data.statusLevelCount,
                                        }}
                                    />
                                )}
                                {data.currentWorkspace.isSwonkieDev && data.hasActiveSubscription && (
                                    <DevOnboarding />
                                )}
                                {!data.currentWorkspace.isSwonkieDev && <OverQuotaGate />}
                                <XCreditsDialog />
                            </SocketProvider>
                        </MenuProvider>
                    </PaymentProvider>
                </TeamPermissionsProvider>
            </SessionProvider>
            <SubscriptionAccessControl hasActiveSubscription={data.hasActiveSubscription} />
        </AndieProvider>
    );
}
